import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {NotificationComponent} from "./notification";

@Component
export class NotificationsZone extends Vue {
  @Getter notifications;

  renderNotifications() {
    return this.notifications.map((notification, idx) => <NotificationComponent key={idx}  notification={notification}/>);
  }

  render() {
    return (
      <div class="notifications">
        {this.renderNotifications()}
      </div>
    );
  }

}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3cf3c2a4/notifications-zone.tsx" });